import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from '../constants';
import { PayInTypeResource } from './types';

export default (makeCall: MakeCall) => () =>
  makeCall<PayInTypeResource>(
    'GET',
    `${APIV2_URL}/payment/method/pay-in-types`,
  );
